"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentType = void 0;
var DocumentType;
(function (DocumentType) {
    DocumentType["Cust"] = "Cust";
    DocumentType["Payment"] = "Payment";
    DocumentType["Sales"] = "Sales";
    DocumentType["CashDiscount"] = "CashDiscount";
    DocumentType["Settlement"] = "Settlement";
    DocumentType["GeneralJournal"] = "GeneralJournal";
    DocumentType["OverUnder"] = "OverUnder";
    DocumentType["ExchangeAdjustment"] = "ExchAdjustment";
    DocumentType["PennyDifference"] = "PennyDifference";
    DocumentType["WriteOff"] = "WriteOff";
})(DocumentType = exports.DocumentType || (exports.DocumentType = {}));
//# sourceMappingURL=document-type.enum.js.map